import { G_bounds } from "../../../utils/globals/globals";
import getBoundsMap from "./get-bounds-map";
import getMaxSide from "./get-max-side";

/**
 * Get and set the element bounds
 * @param {TorusElement} element
 * @param {TriggerProps | null} [trigger]
 * @param {Number | null} [ratio]
 * @param {HTMLElement | null} [target]
 * @param {Boolean} [force]
 * @returns {BoundsProps | null}
 */
const setBounds = function (
  element,
  trigger,
  ratio,
  target = null,
  force = false
) {
  ratio = ratio || 1;

  const boundsTriggers = new Set(["viewport", "pointer", "scroll"]);

  const type = /** @type {String} */ (trigger?.get("type"));

  if (element["tor-bounds"]) {
    return element["tor-bounds"];
  }

  if (!force && !boundsTriggers.has(type)) {
    return null;
  }

  const bounds = element.getBoundingClientRect();
  const B = /** @type {BoundsProps} */ (getBoundsMap(bounds, ratio));

  if (trigger?.get("pointer") && !B.get("max-diagonal")) {
    const max = getMaxSide(B);
    const corner = /** @type {Number} */ (max.get("corner"));
    const xSide = max.get("x-side");
    const ySide = max.get("y-side");

    B.set("max-diagonal", Math.round(corner));
    B.set("max-x-side", xSide);
    B.set("max-y-side", ySide);
  }

  element["tor-bounds"] = B;

  return B;
};

export default setBounds;
